import { useState } from 'react';
import { Link } from 'react-router-dom';
import { alertText, useAlerts } from '../lib/alerts';
import { useNames } from '../lib/directory';
import { fmtTime } from '../lib/format';
import { Dialog, useToast } from './ui';

/** 配車マップに浮かせる警告の一覧（強い警告を上に） */
export function AlertsPanel() {
  const { alerts, ack } = useAlerts();
  const toast = useToast();
  const names = useNames();
  const [acking, setAcking] = useState<string | null>(null);
  const [memo, setMemo] = useState('');
  if (!alerts.length) return null;
  return (
    <section className="panel" aria-label="警告" style={{ padding: 12, display: 'grid', gap: 8, maxHeight: '60vh', overflow: 'auto', borderTop: '4px solid var(--alert)' }}>
      <b style={{ fontSize: 13 }}>警告 {alerts.length} 件</b>
      {alerts.map((a) => (
        <div key={a.id} style={{ borderLeft: `4px solid ${a.level === 'alert' ? 'var(--alert)' : 'var(--jam)'}`, background: 'var(--surface-2)', borderRadius: 10, padding: '8px 10px', display: 'grid', gap: 4 }}>
          <span style={{ fontWeight: 700, fontSize: 13 }}>{alertText(a, names)}</span>
          <span style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 12 }} className="muted">
            {fmtTime(a.since)}〜
            {a.driverId && <Link to={`/drivers/${a.driverId}`}>ドライバー詳細</Link>}
            {a.kind.startsWith('rollcall') || a.kind === 'alcohol' || a.kind === 'rest_short' ? <Link to="/roll-calls">点呼へ</Link> : null}
            {a.kind === 'issue' ? <Link to="/issues">問題報告へ</Link> : null}
            <span style={{ flex: 1 }} />
            {a.needsAck && <button className="btn sm" onClick={() => { setAcking(a.id); setMemo(''); }}>対応済みにする</button>}
          </span>
        </div>
      ))}
      {acking && (
        <Dialog title="対応済みにする" onClose={() => setAcking(null)}>
          <div className="field"><label htmlFor="ack-memo">対応したこと（任意）</label><input id="ack-memo" maxLength={200} value={memo} onChange={(e) => setMemo(e.target.value)} placeholder="例：荷主に遅れを連絡済み" /></div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <button className="btn" onClick={() => setAcking(null)}>やめる</button>
            <button className="btn pri" onClick={async () => { await ack(acking, memo || undefined); setAcking(null); toast('対応済みにしました'); }}>対応済みにする</button>
          </div>
        </Dialog>
      )}
    </section>
  );
}
